import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import Swal from "sweetalert2";
import { ResponseInterceptor } from "usermanagement-boothelp/src/app/core/interceptors/response.interceptor";
import { LogoutAdfsComponent } from "@app/modules/auth/logout-adfs/logout-adfs.component";
import { mdConfig } from '@app/configs/properties.config';
import { BsModalService } from "ngx-bootstrap/modal";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class CustomErrorInterCepter extends ResponseInterceptor {
  private extendRouter: Router;
  //   constructor(private router: Router) { }
  constructor(
    router: Router,
    private modalService: BsModalService,
    private translate:TranslateService
  ) {
    super(router)
    this.extendRouter = router;
  }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: any) => {
        if (event instanceof HttpResponse) {          
          if (event.body && event.body.status === "fail") {
            let externalLink = JSON.parse(
              sessionStorage.getItem("externalLink") || "{}"
            );
            console.log("intercept session  : ",event.body.code)
            if (event.body.code === "AUTHENTICATION_FAIL") {
              Swal.fire({
                title: this.translate.instant("Authentication"),
                text: this.translate.instant(event.body.message),
                type: "warning",
                buttonsStyling: false,
                showCancelButton: false,
                confirmButtonText: "Close",
                confirmButtonClass: "btn btn-secondary btn-fill swal2-close-btn",
              }).then((result) => {
                sessionStorage.removeItem("currentUser");
                sessionStorage.removeItem('mailboxUser');
                sessionStorage.removeItem("permissionList");
                sessionStorage.removeItem('sessionId');
                sessionStorage.removeItem('unlockAt');
                sessionStorage.removeItem('uidOtp');
                sessionStorage.removeItem("_session");

                this.logout();
              });
            } else if (event.body.code === "SESSION_EXPIRE") {
              Swal.fire({
                title: this.translate.instant("Authentication"),
                text: this.translate.instant("Session Expired"),
                type: "warning",
                buttonsStyling: false,
                showCancelButton: false,
                confirmButtonText: "Close",
                confirmButtonClass: "btn btn-secondary btn-fill swal2-close-btn",
              }).then((result) => {
                sessionStorage.removeItem("currentUser");
                sessionStorage.removeItem('mailboxUser');
                sessionStorage.removeItem("permissionList");
                sessionStorage.removeItem('sessionId');
                sessionStorage.removeItem('unlockAt');
                sessionStorage.removeItem('uidOtp');
                sessionStorage.removeItem("_session");
                this.logout();
              });
            } else {
              super.intercept(request, next);
            }
          }
        }
      })
    );
  }

  logout(){    
    this.modalService.show(LogoutAdfsComponent, {      
      ...mdConfig,
      class: "modal-lg",
    });  
  }
}
